import { createSlice } from "@reduxjs/toolkit";
import {
  Banner,
  IconCard,
  Brochure,
  EntertainingCardSlider,
  GridItems,
} from "@/utils/types/aem";
import { getEntertainingData } from "./actions";
 
const initialState = {
  isLoading: false,
  isError: false,
  Banner: {} as Banner,
  IconCard: {} as IconCard,
  Brochure: {} as Brochure,
  GridItems: {} as GridItems,
  slider: {} as EntertainingCardSlider,
  itemOrder: [] as any,
  breadcrumps: {} as any,
};
 
const GetEntertainingDataSlice = createSlice({
  name: "entertaining",
  initialState,
  reducers: {
    setEntertainingData: (state, action) => {
      // state.isLoading = false;
      state.itemOrder =
      action.payload[":items"]["root"][":items"]["container"][":items"][
        "container"
      ][":itemsOrder"];
    state.Banner =
      action.payload[":items"]["root"][":items"]["container"][":items"][
        "container"
      ][":items"]["banner"];
    state.IconCard =
      action.payload[":items"]["root"][":items"]["container"][":items"][
        "container"
      ][":items"]["iconcards"];

      const containerItems =
  action.payload[":items"]?.["root"]?.[":items"]?.["container"]?.[":items"]?.["container"]?.[":items"];

if (containerItems) {
  const bannerKey = Object.keys(containerItems).find((key) =>
    key.startsWith("banner_")
  );

  if (bannerKey) {
    state.Brochure = containerItems[bannerKey];
  }
}
    state.GridItems =  
      action.payload[":items"]["root"][":items"]["container"][":items"][
        "container"
      ][":items"]["columncontrol"][":items"];
    state.slider =
      action.payload[":items"]["root"][":items"]["container"][":items"][
        "container"
      ][":items"]["entertainingcardslid"];
    state.breadcrumps =
      action.payload[":items"]["root"][":items"]["experiencefragment-header"][":items"]["root"][":items"]["breadcrumb"];
      state.isLoading = false;
      state.isError = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getEntertainingData.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(getEntertainingData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.itemOrder =
        action.payload[":items"]["root"][":items"]["container"][":items"][
          "container"
        ][":itemsOrder"];
      state.Banner =
        action.payload[":items"]["root"][":items"]["container"][":items"][
          "container"
        ][":items"]["banner"];
      state.IconCard =
        action.payload[":items"]["root"][":items"]["container"][":items"][
          "container"
        ][":items"]["iconcards"];
      state.Brochure =
        action.payload[":items"]["root"][":items"]["container"][":items"][
          "container"
        ][":items"]["banner_163137736"];
      state.GridItems =  
        action.payload[":items"]["root"][":items"]["container"][":items"][
          "container"
        ][":items"]["columncontrol"][":items"];
      state.slider =
        action.payload[":items"]["root"][":items"]["container"][":items"][
          "container"
        ][":items"]["entertainingcardslid"];
      state.breadcrumps =
        action.payload[":items"]["root"][":items"]["experiencefragment-header"][":items"]["root"][":items"]["breadcrumb"];
    });
    builder.addCase(getEntertainingData.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});
 
export const {
  setEntertainingData
} = GetEntertainingDataSlice.actions;

export const getEntertainingDataSlice = GetEntertainingDataSlice.reducer;